import /*React,*/ { PureComponent } from 'react'
import ReactDOM from 'react-dom'

import Timeout from 'mixins/Timeout'
import { ratio } from 'mixins/Ratio'

@Timeout
class Ratio extends PureComponent {
    render() {
        return this.props.children
    }

    handleUpdateView__Ratio = () => {
        // console.log( 'RatioMixin Update' )

        var element = ReactDOM.findDOMNode( this )

        if( element && element.querySelectorAll )
        {
            const { value = 1, side = "width", padding = false } = this.props

            const width      = parseFloat( element.clientWidth )
            const lastWidth  = parseFloat( element.getAttribute( 'data-width' ) )

            if( lastWidth !== width )
            {
                ratio( element, value, side, padding )

                element.setAttribute( 'data-width', width )
            }

            this.props.setTimeout( this.handleUpdateView__Ratio, 200 )
        }
    }

    componentDidMount() {
        this.handleUpdateView__Ratio()
    }

    componentDidUpdate() {
        this.handleUpdateView__Ratio()
    }
}

export default Ratio